import React from 'react';

const Contact = () => {
return (
<section
  className="contact-ban"
  role="img"
  aria-label="contact"
  style={{ backgroundImage: "url(assets/img/contact-ban.png)" }}
>
  <div className="container-lg inner-container text-white">
    <div className="row">
      <div className="col-xl-7 col-md-5">
        <h1 className="top-hh">Contact</h1>
        <h2 className="sec-hh">We’d love to hear from you!</h2>
      </div>
      <div className="col-xl-5 col-md-7">
        <h5>Please ﬁll out this form, and one of us will reach out to you:</h5>
        <div className="contact-hubspot-from-fix"></div>
      </div>
    </div>
  </div>
</section>


  );
};

export default Contact;